<template>
  <el-dialog width="30%" :visible.sync="checkedMealTimeBoxState">
    <add-product-dialog :resourceObj="resourceObj" :productObj="productObj" :chenckBudgteObj="chenckBudgteObj" :keyStr="keyStr" 
      @closeDialog="closeDialog" ref="addProductDialog">
        
    </add-product-dialog>
  </el-dialog>
</template>

<script>
import addProductDialog from './addProductDialog.vue'
import {addProductMixin} from './addProductMixin'
export default {
  components: { addProductDialog },
  mixins:[addProductMixin],
  methods:{
    openDialog(item,item2,chenckBudgteObj,keyStr){
      this.beforeOpenDialog(item,item2,chenckBudgteObj,keyStr)
    },
  }
}
</script>

<style>

</style>